export default "__VITE_ASSET__3462ba3b__"